import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfigExpedicaoResponse } from '../../responses/vendas/get-config-expedicao.response';
import { ConfigExpedicaoLookupsResponse } from '../../responses/vendas/config-expedicao-lookups.response';
import { ConfigExpedicaoRequest } from '../../requests/vendas/config-expedicao.request';

@Injectable({
    providedIn: 'root',
})
export class ConfigExpedicaoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'ConfigExpedicao';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(): Observable<GetConfigExpedicaoResponse> {
        return this.httpClient
            .get<GetConfigExpedicaoResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookups(): Observable<ConfigExpedicaoLookupsResponse> {
        return this.httpClient
            .get<ConfigExpedicaoLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: ConfigExpedicaoRequest): Observable<GetConfigExpedicaoResponse> {
        const url = `${this.apiUrl}/idConfigExpedicao/${id}`;
        return this.httpClient
            .put<GetConfigExpedicaoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
